import styled from 'styled-components';
import { theme } from '../theme';

// Page Container Styles
export const PageContainer = styled.div`
  min-height: 100vh;
  background: var(--background);
  padding: 0;
  display: flex;
  flex-direction: column;
  /* Ensure sticky positioning works properly */
  overflow-x: hidden;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding-bottom: 80px; /* Space for bottom navigation */
  }
`;

export const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 1.5rem;
  margin-top: 1rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 2rem;
  /* Add top padding to account for fixed navigation */
  padding-top: 80px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    padding: 0 1rem;
    padding-top: 70px;
  }
`;

export const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
  text-shadow: none;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1.8rem;
  }
`;

export const PageDescription = styled.p`
  font-size: 1rem;
  color: var(--text-secondary);
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 0.9rem;
    line-height: 1.5;
  }
`;

export const PageContent = styled.div`
  flex: 1;
  width: 100%;
  padding: 0 0 2rem 0;
  /* Add top padding to account for fixed ProfileTopNav */
  padding-top: 80px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 0 0 1.5rem 0;
    padding-top: 70px;
  }
`;

export const PageActions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid ${theme.colors.border.light};
`;

export const ActionButton = styled.button`
  background: ${theme.colors.gradients.primary};
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
  margin: 0 0.5rem;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.medium};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const BackButton = styled.button`
  background: transparent;
  border: 1px solid var(--border-medium);
  color: var(--text-primary);
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background: var(--bg-secondary);
    border-color: ${theme.colors.border.orange};
  }
`;

// Loading States
export const PageLoading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: var(--text-primary);
`;

export const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid var(--border-light);
  border-top: 3px solid ${theme.colors.primary};
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const LoadingText = styled.div`
  font-size: 1rem;
  color: var(--text-secondary);
`;

// Error States
export const PageError = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  color: var(--text-primary);
`;

export const ErrorMessage = styled.div`
  font-size: 1.1rem;
  color: ${theme.colors.error};
  margin-bottom: 1rem;
  padding: 1rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-medium);
  border-radius: 8px;
  max-width: 500px;
`;

export const ErrorAction = styled.button`
  background: ${theme.colors.gradients.warm};
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.medium};
  }
`;

export const SuccessNotification = styled.div`
  position: fixed;
  top: 90px;
  left: 50%;
  transform: translateX(-50%);
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  padding: 1rem 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 11000;
  font-weight: 500;
  animation: slideDown 0.3s ease-out;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translate(-50%, -20px);
    }
    to {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }
`;
